import { useState } from 'react';
import { DatePicker, Radio, RadioChangeEvent } from 'antd';
import locale from 'antd/es/date-picker/locale/ko_KR';
import dayjs, { Dayjs } from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import weekday from 'dayjs/plugin/weekday';
import './PeriodMenu.scss';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

export type DayjsType = Dayjs | '';

interface PeriodMenuProps {
  startDate: DayjsType;
  endDate: DayjsType;
  defaultValue?: (string | number)[];
  onChange: (startDate: DayjsType, endDate: DayjsType) => void;
  excludeKeys?: string[];
}

const PeriodMenu: React.FC<PeriodMenuProps> = (props) => {
  const { startDate, endDate, onChange, excludeKeys = [] } = props;
  const [chekedButton, setCheckedButton] = useState(JSON.stringify(props.defaultValue || ['all']));

  const PERIOD_OPTIONS = [
    { id: 'all', label: '전체', value: ['all'] },
    { id: 'day-1', label: '1일', value: ['day', 1] },
    { id: 'day-7', label: '1주일', value: ['day', 7] },
    { id: 'month-1', label: '1개월', value: ['month', 1] },
    { id: 'month-3', label: '3개월', value: ['month', 3] },
  ];

  const filteredOptions = PERIOD_OPTIONS.filter((option) => !excludeKeys.includes(option.id));

  const handleDateRangeChange = (e: RadioChangeEvent) => {
    const [standard, number] = JSON.parse(e.target.value);
    if (standard === 'all') {
      onChange('', '');
    } else if (standard === 'day') {
      onChange(dayjs().subtract(number, 'day'), dayjs(new Date()));
    } else if (standard === 'month') {
      onChange(dayjs().subtract(number, 'month'), dayjs(new Date()));
    }

    setCheckedButton(e.target.value);
  };

  return (
    <div className="period-menu">
      <Radio.Group
        options={filteredOptions.map((option) => ({ label: option.label, value: JSON.stringify(option.value) }))}
        onChange={handleDateRangeChange}
        optionType="button"
        value={chekedButton}
      />
      <DatePicker
        locale={locale}
        value={startDate}
        placeholder="시작일"
        onChange={(e) => onChange(e ? dayjs(e) : '', '')}
      />
      <p>{'~'}</p>
      <DatePicker
        locale={locale}
        value={endDate}
        placeholder="종료일"
        onChange={(e) => onChange('', e ? dayjs(e) : '')}
      />
    </div>
  );
};

export default PeriodMenu;
